/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, period: NonNullable<unknown> }} Plan_Price_Per_PeriodInputs */

const en_plan_price_per_period = /** @type {(inputs: Plan_Price_Per_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/${i?.period}`)
};

const es_plan_price_per_period = /** @type {(inputs: Plan_Price_Per_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/${i?.period}`)
};

/**
* | output |
* | --- |
* | "{price}/{period}" |
*
* @param {Plan_Price_Per_PeriodInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_price_per_period = /** @type {((inputs: Plan_Price_Per_PeriodInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Price_Per_PeriodInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_price_per_period(inputs)
	return en_plan_price_per_period(inputs)
});